import React, { useEffect } from "react";

import { Card, IconButton, Tooltip } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TicketHeaderSkeleton from "../TicketHeaderSkeleton";
import ArrowBackIos from "@material-ui/icons/ArrowBackIos";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles(theme => ({
	ticketHeader: {
		display: "flex",
		alignItems: "center",
		gap: theme.spacing(1),
		background: theme.mode === "light" ? "#ffffff" : "#111827",
		flex: "none",
		borderBottom: `1px solid ${theme.mode === "light" ? "#e2e8f0" : "rgba(255,255,255,0.08)"}`,
		minHeight: 68,
		padding: theme.spacing(0.75, 1.25),
		boxShadow: theme.mode === "light" ? "0 1px 0 rgba(15, 23, 42, 0.02)" : "none",
		[theme.breakpoints.down("sm")]: {
			minHeight: 58,
			padding: theme.spacing(0.5, 0.75),
			gap: theme.spacing(0.5),
		},
	},
	backButton: {
		flex: "0 0 auto",
		width: 38,
		height: 38,
		borderRadius: 10,
		color: theme.palette.text.secondary,
		backgroundColor: theme.mode === "light" ? "#f8fafc" : "rgba(255,255,255,0.06)",
		"&:hover": {
			backgroundColor: theme.mode === "light" ? "#eef2f7" : "rgba(255,255,255,0.1)",
			color: theme.palette.primary.main,
		},
		[theme.breakpoints.down("sm")]: {
			width: 34,
			height: 34,
		},
	},
}));

const TicketHeader = ({ loading, children }) => {
	const classes = useStyles();
	const history = useHistory();

	const handleBack = () => {

		history.push("/tickets");
	};

	// useEffect(() => {
	// 	const handleKeyDown = (event) => {
	// 		if (event.key === "Escape") {
	// 			handleBack();
	// 		}
	// 	};
	// 	document.addEventListener("keydown", handleKeyDown);
	// 	return () => {
	// 		document.removeEventListener("keydown", handleKeyDown);
	// 	};
	// }, [history]);

	return (
		<>
			{loading ? (
				<TicketHeaderSkeleton />
			) : (
				<Card
					square
					elevation={0}
					className={classes.ticketHeader}
				>
					<Tooltip title="Voltar para atendimentos">
						<IconButton className={classes.backButton} aria-label="Voltar para atendimentos" onClick={handleBack}>
							<ArrowBackIos fontSize="small" />
						</IconButton>
					</Tooltip>
					{children}
				</Card>
			)}
		</>
	);
};

export default TicketHeader;
